var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SurveyFrontEnd',{attrs:{"content":"此份問卷已失效。"}})
}
var staticRenderFns = []

export { render, staticRenderFns }